import axios from "axios";
import UrlService from "./UrlService";

class SearchService{

    urlService = new UrlService();

    getResources(keyword, params){
        console.log(params);
        const url = this.urlService.getApiURL();
        return axios.get(`${url}?type=searchObject&keyword=${keyword}${params?.free ? "&free=true" : ""}${params?.payed ? "&payed=true" : ""}`);
    }

    getObject(resId){
        const url = this.urlService.getApiURL();
        return axios.get(`${url}?type=searchResource&resId=${resId}`);
    }
}

export default SearchService;